export default function Table({ cols, rows, emptyMsg = "Sin datos", onRowClick }) {
    return (
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              {cols.map((c, i) => (
                <th key={i}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={cols.length} className="table-empty">{emptyMsg}</td></tr>
            ) : rows.map((r, i) => (
              <tr key={i} className={`table-row ${onRowClick ? "table-row--clickable" : ""}`} onClick={() => onRowClick?.(i)}>
                {r.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }